var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverLending = function SvgDiscoverLending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Discover_Lending_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.81 23.065h-9.54a.5.5 0 0 1 0-1h9.32l4.46-4.31a.52.52 0 0 0 .15-.38.59.59 0 0 0-.18-.39.49.49 0 0 0-.39-.13h-.05a.32.32 0 0 0-.2.08l-4.19 2.58a.45.45 0 0 1-.25.07h-5.7a.5.5 0 0 1 0-1h5.57l4.07-2.5c.175-.102.369-.17.57-.2h.05a1.5 1.5 0 0 1 1.19.37 1.55 1.55 0 0 1 .5 1.19 1.59 1.59 0 0 1-.47 1.09l-4.59 4.41a.49.49 0 0 1-.32.12Z",
    fill: "#2F5EA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.92 19.345a.45.45 0 0 1-.3-.1.49.49 0 0 1-.1-.69.77.77 0 0 0 .08-.79.76.76 0 0 0-.67-.42h-7.66a.5.5 0 1 1 0-1h7.66a1.73 1.73 0 0 1 1.56 1 1.699 1.699 0 0 1-.18 1.8.49.49 0 0 1-.39.2Z",
    fill: "#2F5EA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.27 23.555H7.31a.49.49 0 0 1-.5-.49v-6.94a.49.49 0 0 1 .5-.49h4a.5.5 0 0 1 .5.49v6.94a.5.5 0 0 1-.54.49Z",
    fill: "#2F5EA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.48 15.385h-2a.51.51 0 0 1-.5-.5.5.5 0 0 1 .52-.44h2a.491.491 0 0 1 .5.49.5.5 0 0 1-.52.45ZM15.48 13.445h-2a.5.5 0 0 1 0-1h2a.5.5 0 1 1 0 1ZM19.45 15.385h-2a.5.5 0 0 1-.49-.5.49.49 0 0 1 .5-.44h2a.49.49 0 0 1 .49.49.5.5 0 0 1-.5.45ZM19.45 13.445h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1ZM19.45 11.445h-2a.49.49 0 0 1-.347-.84.5.5 0 0 1 .347-.15h2a.5.5 0 0 1 .453.688.492.492 0 0 1-.453.302ZM19.45 9.445h-2a.49.49 0 0 1-.48-.5.491.491 0 0 1 .49-.5h2a.49.49 0 0 1 .49.5.488.488 0 0 1-.5.5ZM23.41 15.385h-2a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.49h2a.5.5 0 0 1 .5.49.51.51 0 0 1-.5.5ZM23.41 13.445h-2a.5.5 0 0 1 0-1h2a.5.5 0 1 1 0 1ZM23.41 11.445h-2a.5.5 0 0 1-.5-.49.51.51 0 0 1 .5-.5h2a.51.51 0 0 1 .5.5.5.5 0 0 1-.5.49Z",
    fill: "#D1B896"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Discover_Lending_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.81 8.445)",
    d: "M0 0h19.38v15.11H0z"
  })))));
};
export default SvgDiscoverLending;